import { Typography, zIndexes } from "@packages/uiKit";
import Image from "next/image";
import styled from "styled-components";

export const StyledAdvantagesStats = styled.div``;

export const StyledStatContainer = styled.div`
  display: flex;
  gap: 26px;
  justify-content: space-between;
`;

export const StyledTextContent = styled.div`
  min-width: 0;

  flex: 1;
  z-index: ${zIndexes.default};
`;

export const StyledDescription = styled(Typography).attrs({
  size: 22,
  weight: 400,
  color: "dark",
})`
  white-space: pre-wrap;
  min-width: 0;
`;

export const StyledImageContainer = styled.div`
  align-self: flex-start;
`;
export const StyledImage = styled(Image)``;

export const StyledNumbers = styled(Typography).attrs({
  size: 53,
  weight: 700,
  color: "dark",
  nowrap: true,
})`
  margin-top: 18px;
`;
